import color from '@ui/style/color.theme'

interface Icon16TimeProps {
	isDark?: boolean
}
export const Icon16Time = ({ isDark }: Icon16TimeProps) => {
	const colorValue = isDark ? color.colWhite : color.colGray5
	const opacityValue = isDark ? 0.6 : 1
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
		>
			<circle
				cx="8"
				cy="8"
				r="6"
				stroke={colorValue}
				strokeWidth="1.2"
				strokeOpacity={opacityValue}
			/>
			<path
				d="M8 4.5V8H11"
				stroke={colorValue}
				strokeWidth="1.2"
				strokeOpacity={opacityValue}
			/>
		</svg>
	)
}
